var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"FQDNOverview"}},[_c('fqdn-table',{attrs:{"fqdns":_vm.fqdns,"statistics":_vm.fqdn_statistics}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }